export default "__VITE_ASSET__926e93ae__"